import { useEffect, useState } from "react";
import "./ProfilePanel.css";
import { loginWithGoogle, logoutUser } from "../auth/auth";
import { useNavigate } from "react-router-dom";
import { getWishlistCount } from "../services/wishlist";
import { useAuthUser } from "../hooks/useAuthUser";

function ProfilePanel({ open, onClose }) {
  // ✅ ALL HOOKS AT TOP — NO RETURNS BEFORE THIS
  const navigate = useNavigate();
  const user = useAuthUser();
  const [wishlistCount, setWishlistCount] = useState(0);

  const isGuest = user?.type === "guest";

  // ✅ useEffect ALWAYS runs
  useEffect(() => {
    // Auth still loading OR guest → reset count
    if (!user || isGuest || !user.id) {
      setWishlistCount(0);
      return;
    }

    const loadCount = async () => {
      const count = await getWishlistCount(user.id);
      setWishlistCount(count);
    };

    loadCount();
    window.addEventListener("wishlist-updated", loadCount);

    return () =>
      window.removeEventListener("wishlist-updated", loadCount);
  }, [user, isGuest]);

  // ✅ ALL CONDITIONS AFTER HOOKS
  if (!open || !user) return null;

  return (
    <div className="profile-overlay" onClick={onClose}>
      <div
        className="profile-panel"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="profile-header">
          <div className="avatar-circle">
            {user?.photo ? (
              <img src={user.photo} alt="avatar" />
            ) : (
              "👤"
            )}
          </div>

          <div className="profile-meta">
            <h3>{isGuest ? "Guest User" : user.name}</h3>
            <p>
              {isGuest ? "Browsing as guest" : user.email}
            </p>
          </div>
        </div>

        <div className="profile-divider" />

        {/* ACCOUNT (Guest only) */}
        {isGuest && (
          <div className="profile-section">
            <h4>Account</h4>
            <button
              className="primary-btn"
              onClick={async () => {
                await loginWithGoogle();
                onClose();
              }}
            >
              Continue with Google
            </button>
          </div>
        )}

        {/* LIBRARY */}
        {!isGuest && (
          <div className="profile-section">
            <h4>Library</h4>
            <button
              className="profile-item"
              onClick={() => {
                onClose();
                navigate("/wishlist");
              }}
            >
              ❤️ My Wishlist
              {wishlistCount > 0 && (
                <span className="badge">{wishlistCount}</span>
              )}
            </button>
          </div>
        )}

        {/* DIVIDER */}
        {!isGuest && <div className="profile-divider" />}

        {/* LOGOUT — LAST */}
        {!isGuest && (
          <div className="profile-section">
            <button
              className="danger-btn"
              onClick={async () => {
                await logoutUser();
                onClose();
              }}
            >
              Logout
            </button>
          </div>
        )}

        {/* FOOTER */}
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default ProfilePanel;
